export default __webpack_public_path__ + "static/media/home-background.ce5af338.png";